<template>
  <button
    type="button"
    class="vs-link-cta vs-reset-form"
    @click="resetForm"
  >
    {{ resetLabel }}
  </button>
</template>

<script>
export default {
  name: 'VsResetForm',
  props: {
    resetLabel: { type: String, default: 'Reset' },
  },
  methods: {
    resetForm() {
      this.$emit('resetForm');
    },
  },
};
</script>
